import React from 'react'
import "./contact.css";

const Contact = () => {
  return (
    <div>
         <div className="container py-5">
        {/* <!-- Header --> */}
        <div className="contact-header fade-in-top" >
            <h1>Let's Work Together</h1>
        </div>

        <div className="container address-content">
        {/* <!-- Contact Info --> */}
        <div className="row  ">
            <div className="col-md-12 col-lg-4 mb-1" data-aos="fade-up" data-aos-delay="100">
                <div className="content-box ">
                    <h3>Phone No:</h3>
                   
                     <h6> <p className="call-text">
                      <a href="tel:+91-8949687368 " rel="nofollow">+91-8949687368 </a></p></h6>
                </div>
            </div>
            <div className="col-md-12 col-lg-4  mb-1" data-aos="fade-up" data-aos-delay="200">
                <div className="content-box  ">
                    <h3>Address:</h3>
                    <h6>301, 3rd Floor, 244-245, Dhruv Marg, Tilak Nagar, Near Baskin-Robins, Gurunanakpura, Raja Park, Jaipur, Rajasthan 302004</h6>
                </div>
            </div>
            <div className="col-md-12 col-lg-4 mb-1" data-aos="fade-up" data-aos-delay="300">
                <div className="content-box  ">
                    <h3>Email:</h3>
                   <h6>sales@codeqlik.com<br/>
                    hr@codeqlik.com</h6>
                </div>
            </div>
        </div>

        <div className="row ">
          <div className="col-lg-8 col-md-12 mb-1" data-aos="fade-up" data-aos-delay="100">
              <div className="content-box ">
                  <h3>Opening Hours: </h3>
                  <h6>Mon to Fri: 9.00am - 8.30pm</h6>
                  <h6>Sat: 10.00am - 6.30pm</h6>
                  <h6>Sun: Closed</h6>
              </div>
          </div>
          <div className="col-lg-4 col-md-12 mb-1" data-aos="fade-up" data-aos-delay="200">
              <div className="content-box  ">
                  <h3>Follow Us:</h3>
                  <div className="social-icons d-flex  gap-3">
                    <a href="#" className="text-white"><i className="fab fa-facebook-f"></i></a>
                    <a href="#" className="text-white"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-white"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-white"><i className="fab fa-instagram"></i></a>
                  </div>
              </div>
          </div>
      </div>


                {/* <!-- Map --> */}
                <div className="map mb-4">
                  <h3 className='text-white'>Find Us Here</h3>
                  <iframe 
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.338889083221!2d75.7830504145374!3d26.912432983131557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db37e00aaaaa!2sJaipur,%20Rajasthan!5e0!3m2!1sen!2sin!4v1234567890" 
                      allowfullscreen="" loading="lazy">
                  </iframe>
              </div>
        </div>


    </div>
    </div>
  )
}

export default Contact